import { render, staticRenderFns } from "./OrganAllocationReport.vue?vue&type=template&id=0d2861e2"
import script from "./OrganAllocationReport.vue?vue&type=script&lang=js"
export * from "./OrganAllocationReport.vue?vue&type=script&lang=js"
import style0 from "./OrganAllocationReport.vue?vue&type=style&index=0&id=0d2861e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports